import React from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import Layout from './helpers/Layout';
import ExampleTwo from './routes/example/ExampleTwo';

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Switch>

          <Route exact={true} path={"/"} component={ExampleTwo} />

          <Route path={"/"}>
            <Redirect to={"/"} />
          </Route>

        </Switch>
      </Layout>
    </BrowserRouter>
  );
}

export default App;